export default __webpack_public_path__ + "static/media/gu.b55158cd.svg";